<div class="container-content">
  <div class="p-grid p-fluid text-center">
    <img [src]="imagePath" class="logo">
  </div>
  <div class="p-grid p-fluid onboarding-heading">
    <div class="p-col-12 p-md-12 p-lg-12 text-center" [innerHTML]="welcomeText"></div>
  </div>
  <div class="p-grid p-fluid">
    <p class="text__support"><span>{{supportText}}</span></p>
  </div>
</div>
